module.exports = __webpack_public_path__ + "static/media/cuttingSound.7e0b2a5e.mp3";